module.exports = __webpack_public_path__ + "ci_vendor_prometheus.03582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_prometheus.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_prometheus.svg
// module chunks = main